// hooks/useGetWithdrawals.ts
import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const apiUrl = process.env.REACT_APP_API_URL;

interface WithdrawalResponse {
  response: any;
  message?: string;
}

const useGetWithdrawals = (page: number = 1, limit: number = 10) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const [transaction, setTransaction] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTransactionStatus = useCallback(async () => {
    if (!isAuthenticated) return;

    setLoading(true);
    setError(null);

    try {
      const tk = await getAccessTokenSilently();

      const response = await axios.get<WithdrawalResponse>(
        `${apiUrl}/api/v1/withdrawaltransaction/history?page=${page}&limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${tk}`,
          },
        }
      );

      setTransaction(response.data?.response ?? []);
    } catch (err) {
  
      setError("Error fetching withdrawal transactions");
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated, getAccessTokenSilently, page, limit]);

  useEffect(() => {
    fetchTransactionStatus();
  }, [fetchTransactionStatus]);

  return { transaction, loading, error, refetch: fetchTransactionStatus };
};

export default useGetWithdrawals;
